import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useMarketOps } from "../MarketOpsContext";
import { ASSET_STATUS_META } from "../../utils/portfolio";

export default function Assets() {
  const { assets } = useMarketOps();
  return <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, overflowX: "auto" }}>
    <Typography variant="h6">Portfolio &amp; Onboarding</Typography>
    <Typography color="text.secondary" sx={{ my: 1 }}>Saved asset configuration. Market registration, telemetry and prequalification still need to be connected and verified.</Typography>
    <Table size="small">
      <TableHead><TableRow>{["Asset", "Asset type", "Status", "Bidding zone", "Storage MW / MWh", "Setup"].map((label) => <TableCell key={label}>{label}</TableCell>)}</TableRow></TableHead>
      <TableBody>{assets.map((a) => <TableRow key={a.id}>
        <TableCell>{a.name || a.id}</TableCell><TableCell>{a.systemType || "Not set"}</TableCell>
        <TableCell>{ASSET_STATUS_META[a.status]?.label || "Not set"}</TableCell><TableCell>{a.biddingZone || "Not set"}</TableCell>
        <TableCell>{a.powerMw ?? "â€”"} / {a.energyMwh ?? "â€”"}</TableCell>
        <TableCell>{a.issues.length ? a.issues.join(" ") : "Awaiting verified onboarding"}</TableCell>
      </TableRow>)}</TableBody>
    </Table>
    <Button component={RouterLink} to="/project/overview" sx={{ mt: 2 }}>Overview &amp; Assets</Button>
  </Paper>;
}
